import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SIDEBAR_TOGGLE } from '../actions';
import { Link, IndexLink } from 'react-router';
import { getLocalStorageInfo, eraseGlobalCookie } from '../../utils';
import { trackLogOut } from '../../utils/mixpanel'
import { imgStoragePath } from '../../constants';
import ToolTipHover from './ToolTipHover';
import dashboardIcon from '../../shared/assets/img/dashbord_icon.svg';
import homeIcon from '../../shared/assets/img/home_icon.png';
import  templateIcon  from '../../shared/assets/img/templates.svg';
import config from '../../config';
import { onCheckPermission } from '../../utils_v2';
import { smbcInstance } from '../../shared_elements/components';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';class PrySidebarExp extends Component{
  constructor(props){
    super(props);
  }
  logout = () => {
    trackLogOut(getLocalStorageInfo())
    localStorage.clear();
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('redirectURIProjects')
    eraseGlobalCookie('domain')
    eraseGlobalCookie('hasMultilLessorAccess')
    this.props.sidebarToggleFn(false)
    browserHistory.push('/login');
  }
  
  primaryNavLink = (imgIcon, imgWidth, url, activeClassName, flag, targetId, placement, title, linkAccess, isBeta) => {
    if(linkAccess){
      return (
        <li>
          <Link to={url} onClick={() => {localStorage.removeItem('lisitng_url');this.props.sidebarToggleFn(false)}} style={(title == 'Co') ? {cursor: 'not-allowed'} : {}} className={(targetId == 'userManagement' ? ' ': ' ') + (targetId == 'usersManager' ? 'utility-block ': ' ')  + (activeClassName ? 'flex-centered active' :'flex-centered')}>
            <img id={targetId} src={imgStoragePath+imgIcon} alt="nav-icon" width={imgWidth} />
            <br/>
            <span className="sideBarSubheading">{title}</span>
          </Link>
        </li>
      )
    }else{
      return null
     }
  }
  showToolTip = (flag, targetId, placement, title) => {
    if(!flag){
      return(
        <ToolTipHover tagetId={targetId} placement={placement}> {title} </ToolTipHover>
      )
    }else{ return null }
  }
  render(){
    var { sideBarStatus,  notificationOpen, dashSw } = this.props;
    sideBarStatus = false;
    const pathname = this.props.pathName;
    const userDetail = JSON.parse(localStorage.getItem('userInfo'));
    let is_saas = false
    Object.keys(userDetail.user.permission).map(permission => {
      if(userDetail.user.permission[permission].is_saas == true){
        is_saas = true
      }
      return permission
    })
    return(
      <div className="prySidebarExp" style={ notificationOpen || this.props.topNotice ? {marginTop: '30px'} : null }>
        <div className="dashboard-block">
          <ul className="list-unstyled" style={{ marginTop: userDetail.defaultLessor.on_trail ? '30px' : '0px'  }}>
              {/* <li>
                <Link className="flex-centered" to={`${config.domain.subDomian}`} target="_blank">
                  <img id="home" src={homeIcon} alt="img" width='25'/>
                  <br/>
                  <span className="sideBarSubheading ">
                    Home
                  </span>
                </Link>
              </li> */}
              <li>
                {onCheckPermission('expense_management','expense','R') ?
                <Link  onClick={() => this.props.sidebarToggleFn(false)}  className={pathname.includes('/fleet/technical/dashboard') ? "active" : ""}   to={`/fleet/technical/dashboard`}>
                  <img id="home" src={homeIcon} alt="img" width='25'/>
                  <br/>
                  <span className="sideBarSubheading ">
                  Home
                  </span>
                </Link>:null}
                </li>
                <li>
                  <IndexLink onClick={() => this.props.sidebarToggleFn(false)} to='/technical/projects?project_status=all' activeClassName="active" className={(pathname.includes('technical/project') &! pathname.includes('technical/projects/tracker')) || pathname.includes('/forms/') ? 'active':pathname === '' || pathname === '/' ? "flex-centered active" : "flex-centered"}>
                    <img src={imgStoragePath+'phase-2/technical_projects.png'} alt="nav-icon" width={'20'} />
                    <br/>
                    <span className="sideBarSubheading">Projects</span>
                  </IndexLink>
                </li>
                { onCheckPermission('project_management', 'tracker','R') ?
                  <li>
                    <Link to='/technical/projects/tracker' className={pathname.includes('projects/tracker') || pathname.includes('technical/man-power/')? 'active':''}>
                      <img src={imgStoragePath+'phase-2/project_tracker.png'} alt="nav-icon" width={'20'} />
                      <br/>
                      <span className="sideBarSubheading">Trackers</span>
                    </Link>
                  </li>:null
                }
                { this.primaryNavLink(imgStoragePath+'tableau_analytics.svg', 20, '/analytics/resources', (pathname.includes('/analytics/resources') || pathname.includes('/analytics/projects')), sideBarStatus, 'analytics', 'right', 'Analytics', getLocalStorageInfo().user.account_type === 'Acumen' && (getLocalStorageInfo().user.is_root_user || getLocalStorageInfo().user?.security_groups.filter(item=> [24,29].includes(item?.id))?.length ) )}
                { this.primaryNavLink('Bitmap.png', 20, '/technical/program-planner', (pathname.includes('/technical/program-planner')), sideBarStatus, 'program-planner', 'right', 'Program Planner', (getLocalStorageInfo()?.user?.permission?.program_planner?.dashboard !== undefined && getLocalStorageInfo()?.defaultLessor?.id === 321 || getLocalStorageInfo()?.defaultLessor?.id === 442 )) }
                { smbcInstance ?
                    null :
                    onCheckPermission('project_management', 'opr_report','R') ?
                    <li>
                      <Link to='/technical/opr/report' activeClassName="active" className="flex-centered">
                        <img id="dashboard" src={imgStoragePath+'report_icon.png'} alt="img" width='20'/>
                        <br/>
                        <span className="sideBarSubheading">OPR Report</span>
                      </Link>
                    </li>:null
                }
                 {
                  onCheckPermission('project_management', 'template','R') ?
                  <li>
                    <Link to='/technical/form/templates' activeClassName="active" className="flex-centered">
                      <img id="dashboard" src={templateIcon} alt="img" width='20' style={{opacity:'0.8'}}/>
                      <br/>
                      <span className="sideBarSubheading">Templates</span>
                    </Link>
                  </li> : null
                 }
            {
              onCheckPermission('project_management', 'template', 'R') ?
                <li>
                  <Link to='/technical/tags' activeClassName="active" className="flex-centered">
                     <LocalOfferOutlinedIcon id="tags" fontSize='small' style={{color:'white',opacity:'0.8'}} />
                    <br />
                    <span className="sideBarSubheading">Tags</span>
                  </Link>
                </li> : null
            }
          </ul>
        </div>
     </div>
    )
  }
}

const mapStateToProps = state => ({
  notificationOpen:state.sharedReducers.notificationOpen,
  dashSw:state.sharedReducers.dashSw,
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    sidebarToggleFn: (statusFlag) => dispatch({
      type: SIDEBAR_TOGGLE,
      payload: false
    }),
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(PrySidebarExp);
